export const SIGNALS_TERMS = {
  v1: "By activating Subscriber Signals, you confirm that as the data controller of your subscriber data you have authority to enable third-party data enrichment for your subscriber lists, and that your use complies with all applicable laws including your consent obligations to your subscribers."
}

export const CURRENT_SIGNALS_TERMS_VERSION = "v1"
